import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    '& p': {
      fontSize: '1.2rem',
      color: '#1A1C19',
    },

    '& .MuiTablePagination-selectRoot': {
      margin: '0px 15px',
    },

    '& .MuiInputBase-input': {
      border: `1px solid ${theme.palette.secondary.light}`,
      borderRadius: '4px',
      padding: '3px 35px 3px 5px',
      color: '#1A1C19',
      fontSize: '1.2rem',
      fontWeight: 600,
    },

    '& .MuiSelect-select:focus': {
      backgroundColor: 'transparent',
    },

    '& button:not(.Mui-disabled)': {
      '& svg': {
        color: '#1A1C19',
      },
    },

    '& .MuiSelect-icon': {
      color: '#1A1C19',
      marginRight: '5px',
    },

    '& .MuiTablePagination-spacer': {
      flex: 'none',
    },
  },

  list: {
    '& li': {
      fontSize: '1.2rem',
      color: '#1A1C19',
      borderBottom: '1px solid #DEE5DA',

      '&:last-child': {
        borderBottom: 'none',
      },

      '&.Mui-selected': {
        color: '#727970',
        backgroundColor: 'transparent',
      },
    },
  },

  paper: {
    border: `1px solid ${theme.palette.secondary.light}`,
    borderRadius: '0px 0px 4px 4px',

    '& ul': {
      padding: '0px',
    },
  },
}))
